<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>
<!-- Header -->
<div id="header-container">
  <div>
    <h1 id="header-text">Propulsion Scenario Duplicate Record Maintenance</h1>
  </div>
  <div id="button-container" class="button-container">
    <button mat-raised-button id="get-records-button"
            class="get-records-button"
            color="primary"
            [disabled]="selectedRow === null"
            (click)="getPropDupeRecords()">
      Get Records
    </button>
    <button mat-raised-button id="scan-button"
            class="scan-button"
            color="primary"
            (click)="scanPropScenDupes()">
      Scan for Dupes
    </button>
  </div>
</div>

<!--    Main Option Table-->
<div class="gfs-table" *ngIf="this.propScenWithDupes !== null && this.propScenWithDupes.length > 0">
  <ag-grid-angular
    style="height: 100%; width:100%;"
    class="ag-theme-quartz"
    [rowData]="propScenWithDupes"
    [columnDefs]="propScenColumns"
    [autoSizeStrategy]="autoSizeStrategy"
    [rowSelection]="rowSelection"
    (rowSelected)="onSelect($event)"
  ></ag-grid-angular>
</div>

<div class="save-prop-modification-container"
     *ngIf="this.propScenWithDupes !== null && this.propScenWithDupes.length > 0">
  <h2>Save Propulsion Modifications</h2>
  <app-upload-button class="upload" [apiUrl]="excelService.excelSheetUrl"
                     (eventEmitter)="upload($event)"></app-upload-button>
</div>


